import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./en.json";
import th from "./th.json";

export const defaultNS = "translation";
export const supportedLngs = ["en", "th"] as const;

export const resources = {
  en: { translation: en },
  th: { translation: th },
} as const;

function syncDocumentLanguage(lng: string) {
  if (typeof document !== "undefined") {
    document.documentElement.lang = lng.startsWith("th") ? "th" : "en";
  }
}

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    supportedLngs,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "tb_admin_lang",
      caches: ["localStorage"],
    },
  })
  .then(() => syncDocumentLanguage(i18n.resolvedLanguage ?? i18n.language));

i18n.on("languageChanged", (lng) => {
  syncDocumentLanguage(lng);
});

export default i18n;
